import { registerSW } from 'virtual:pwa-register';

/**
 * Register the service worker and keep it fresh.
 * - immediate: activate as soon as it's ready
 * - onNeedRefresh: a new build is live -> apply it and reload (autoUpdate still
 *   benefits from this on tabs/PWAs that were left open across a deploy)
 * - poll every 5 min so a device left on the app picks up new versions
 */
const updateSW = registerSW({
  immediate: true,
  onNeedRefresh() {
    updateSW(true);
  },
  onRegisteredSW(_swUrl, reg) {
    if (!reg) return;
    setInterval(() => {
      reg.update().catch(() => {});
    }, 5 * 60 * 1000);
  },
});
